module.exports = require("npm:google-maps-api-loader@0.3.0/index.js");